import styled from 'styled-components/macro';

const StyledSpinnerImage = styled.img<{ $height?: number; $width?: number }>`
  height: ${({ $height }) => `${$height}px` || '90px'};
  width: ${({ $width }) => `${$width}px` || '90px'};
`;

export default StyledSpinnerImage;
